import { render } from "./story_form.vue?vue&type=template&id=377d0ad6&scoped=true&lang=pug"
import script from "./story_form.vue?vue&type=script&lang=js"
export * from "./story_form.vue?vue&type=script&lang=js"

import "./story_form.vue?vue&type=style&index=0&id=377d0ad6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377d0ad6"]])

export default __exports__